import React, { useEffect, useState} from "react";
import { Sidebar } from './Helper';
import {  buildMarketFilters, buildCatFilters, getVar } from './Helper';
import styled from 'styled-components';


const SidebarInnerWrap = styled.div`
    padding-top:80px;
    padding-bottom:25px;
    padding-left:30px;
    padding-right:30px;
`;

const StyledLabel = styled.label`
    display:block;
    font-size:14px;
    padding-left:10px;
    margin-bottom:3px;
`;
const StyledCheckbox = styled.input`
    height: 15px;
    width: 15px;
    display: inline-block;
    position: relative;
    top: 3px;
    margin-right:5px;
`;

const StyledImg = styled.img`
    width:25px;
`;

const StyledH3 = styled.h3`
    font-size:15px;
    margin-top:15px;
    margin-bottom:10px;
    color:#000;
    font-weight: 600;
`;
const StyledH2 = styled.h2`
    font-size:18px;
    margin-bottom:30px;
    color:#000;
    font-weight: 600;
`;
const StyledH5 = styled.h5`
    border-bottom: 1px solid #ccc; 
    padding-bottom:15px; 
    margin-bottom:25px;
    font-size: 14px;
    font-weight: 300;
`;
const SectionWrap = styled.div`
    padding-bottom:15px;
`;

const CloseBtn = styled.span`
    padding: 5px 0 0 0;
    border: none;
    text-align: center;
    width: 28px;
    height: 28px; 
    font: 16px/14px Inter;
    color: #c3c3c3; 
    text-decoration: none;
    background: transparent;
    font-size: 30px;
    float: right;
    :hover{
        cursor: pointer;
        color:#000;
    }
`;

const Credits = styled.div`
    position: absolute;
    left:0;
    bottom:15px;
    font-size: 12px;
    color: #666;
    width:100%;
    text-align:center;
`;


function AdvancedFilters({setLeftSidebar, catIds, setLoading, filterAdvancedHanlder}){

    const [markets, setMarkets] = useState([]);
    const [filters, setFilters] = useState([]);
    const [year, setYear] = useState('');

    useEffect(()=>{
        const d = new Date(); 
        setYear(d.getFullYear());
        setMarkets(buildMarketFilters());
        buildCatFilters(setFilters);        
    },[])  
    
    return (
        <>
        <div className="modal" onClick={()=>{setLeftSidebar(false)}}></div>
        <Sidebar width={'350px'}>
            <CloseBtn onClick={()=>{setLeftSidebar(false)}}>x</CloseBtn>
            <SidebarInnerWrap>
            <StyledH2>Advanced Market Filter</StyledH2>
            <StyledH5>Select Area(s) of Interest</StyledH5>
            {markets.map((market)=>{
                return (
                    <SectionWrap key={market.key}>
                    <StyledH3> <StyledImg src={market.imgUrl} alt={market.name} /> {market.name} </StyledH3>
                    {filters.map((filter)=>{
                        return filter.group === market.key ? 
                            (<StyledLabel key={filter.id} >
                            <StyledCheckbox type="checkbox" 
                            className="form-control"
                            onChange={()=>{
                                setLoading(true);
                                filterAdvancedHanlder(filter.id)
                                buildCatFilters(setFilters);
                                }}
                            checked={catIds.includes(filter.id) ? true : false}
                             /> 
                             {filter.label} ({filter.count})
                             </StyledLabel> ) : null;
                    })}
                    </SectionWrap>
                )
            })}        
            </SidebarInnerWrap>    
            <Credits>
                © {year} Parsons Corporation. All rights reserved.<br /> Version {getVar().version}
            </Credits>
        </Sidebar>
        </>
    )
}

export default AdvancedFilters;